import {Pipe, PipeTransform} from '@angular/core';
import {ReportSourceFile} from '../models/report/normalized-report.model';
import {linkifySourceFiles} from '../models/report/report-source-links';

/**
 * Macht die im KI-Antworttext genannten Quelldateien zu Ankern auf die Datei (siehe
 * {@link linkifySourceFiles}). Gehört VOR `normalizeMarkdown` in die Kette: die Ersetzung arbeitet
 * auf dem Markdown-Quelltext, nicht auf dem gerenderten HTML.
 */
@Pipe({
  name: 'reportSourceLinks',
})
export class ReportSourceLinksPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    sources: readonly ReportSourceFile[] | null | undefined,
    projectId: number | null | undefined,
  ): string {
    return linkifySourceFiles(value, sources, projectId);
  }
}
